
import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';

const AuthButtons = () => {
  const navigate = useNavigate();
  
  return (
    <>
      <Button 
        size="sm" 
        className="h-9 rounded-lg bg-primary hover:bg-primary/90 text-primary-foreground shadow-sm hover:shadow transition-all hidden md:flex gap-2"
        onClick={() => navigate('/auth')}
      >
        <Sparkles className="h-4 w-4" />
        <span>Sign In</span>
      </Button>
      
      <Button 
        size="icon"
        variant="ghost"
        className="md:hidden"
        onClick={() => navigate('/auth')}
      >
        <Sparkles className="h-5 w-5" />
      </Button>
    </>
  );
};

export default AuthButtons;
